/** @prettier */
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import {
    questionResult,
    ReviewQuestionDataWithImages,
} from "./testReviewState";
import { Image as ImageData } from "../View/useQuestionImages";
import Image from "../View/Image";

const textForQuestionResult = {
    CORRECT: "Correct!",
    INCORRECT: "Incorrect.",
    UNANSWERED: "You left this question unanswered.",
};

export type QuestionReviewInfoProps = {
    question: ReviewQuestionDataWithImages;
};
const header = (text: string) => (
    <p className="tr-review-section-header">{text}</p>
);
const QuestionReviewInfo = ({ question }: QuestionReviewInfoProps) => {
    const result = questionResult(question);
    const explanationImages =
        question.images?.state === "loaded" &&
        question.images.explanationImages;
    const { reinforcementQuestion } = question;
    return (
        <>
            <p className={`tr-review-result ${result.toLowerCase()}`}>
                {textForQuestionResult[result]}
            </p>
            {header("Key concept")}
            <p>{question.keyConcept}</p>
            {header("Explanation of correct answer")}
            <p>{question.correctAnswerExplanation}</p>
            {header("Explanation of incorrect answers")}
            <p>{question.incorrectAnswerExplanation}</p>
            {explanationImages && (
                <ExplanationImages images={explanationImages} />
            )}
            {reinforcementQuestion && (
                <ReinforcementQuestion {...reinforcementQuestion} />
            )}
            {header("References")}
            <ol>
                {question.references.map((reference) => (
                    <li key={reference}>{reference}</li>
                ))}
            </ol>
        </>
    );
};

type ExplanationImagesProps = { images: ImageData[] };
const ExplanationImages = ({ images }: ExplanationImagesProps) => {
    if (images.length === 0) {
        return null;
    }
    return (
        <>
            {header("Explanation images")}
            <div className="tr-question-images">
                {images.map(({ id, image, fileName }) => (
                    <Image key={id} name={fileName} image={image} />
                ))}
            </div>
        </>
    );
};

type ReinforcementQuestionProps = { question: string; answer: string };
const ReinforcementQuestion = ({
    question,
    answer,
}: ReinforcementQuestionProps) => {
    const [showingAnswer, setShowingAnswer] = useState(false);
    return (
        <>
            {header("Reinforcement question")}
            <p>{question}</p>
            {header("Reinforcement question answer")}
            {showingAnswer ? (
                <p>{answer}</p>
            ) : (
                <p>
                    <Button onClick={() => setShowingAnswer(true)}>
                        Show answer
                    </Button>
                </p>
            )}
        </>
    );
};

export default QuestionReviewInfo;
